export const VERIFIED_LABEL = "Verificado por AutoMapa";
export const VERIFIED_COMPACT_LABEL = "Verificado";
export const PENDING_LABEL = "Verificación en proceso";

export const VERIFIED_TOOLTIP =
  "AutoMapa confirmó datos principales del concesionario, como identidad comercial, ubicación y canal de contacto. La verificación no garantiza el estado mecánico, legal o documental del vehículo.";

export const PENDING_TOOLTIP =
  "Este concesionario está en proceso de revisión por AutoMapa.";

export const VERIFICATION_INFO_PATH = "/seguridad";

const BLOCKED_DEALER_STATUSES = new Set(["suspended", "rejected", "archived"]);
const ELIGIBLE_DEALER_STATUSES = new Set(["active", "onboarding"]);

export function normalizeDealerForVerification(input) {
  if (!input) return null;
  if (input.dealerVerificationStatus != null || input.dealerStatus != null) {
    return {
      verificationStatus: input.dealerVerificationStatus || "unverified",
      status: input.dealerStatus || "onboarding",
      publicProfileEnabled: input.dealerPublicProfileEnabled !== false,
    };
  }
  return {
    verificationStatus: input.verificationStatus || "unverified",
    status: input.status || "onboarding",
    publicProfileEnabled: input.publicProfileEnabled !== false,
  };
}

export function shouldShowDealerVerificationBadge(dealerOrListing) {
  if (!dealerOrListing) return false;
  if (typeof dealerOrListing.dealerVerified === "boolean") {
    return dealerOrListing.dealerVerified;
  }
  const normalized = normalizeDealerForVerification(dealerOrListing);
  if (!normalized) return false;
  if (normalized.verificationStatus !== "verified") return false;
  if (BLOCKED_DEALER_STATUSES.has(normalized.status)) return false;
  if (!ELIGIBLE_DEALER_STATUSES.has(normalized.status)) return false;
  if (!normalized.publicProfileEnabled) return false;
  return true;
}

export function shouldShowDealerPendingBadge(dealer, context = "profile") {
  if (context !== "profile") return false;
  const normalized = normalizeDealerForVerification(dealer);
  if (!normalized) return false;
  if (normalized.verificationStatus !== "pending") return false;
  if (BLOCKED_DEALER_STATUSES.has(normalized.status)) return false;
  if (!normalized.publicProfileEnabled) return false;
  return true;
}

export function getDealerVerificationPublicState(dealer) {
  const normalized = normalizeDealerForVerification(dealer);
  if (!normalized) {
    return { state: "hidden", showBadge: false, showPending: false };
  }
  if (shouldShowDealerVerificationBadge(normalized)) {
    return { state: "verified", showBadge: true, showPending: false };
  }
  if (shouldShowDealerPendingBadge(normalized, "profile")) {
    return { state: "pending", showBadge: false, showPending: true };
  }
  return { state: "hidden", showBadge: false, showPending: false };
}

export function getDealerVerificationLabel(dealer, context = "default") {
  const state = getDealerVerificationPublicState(dealer);
  if (state.state === "verified") {
    return context === "compact" || context === "card" ? VERIFIED_COMPACT_LABEL : VERIFIED_LABEL;
  }
  if (state.state === "pending" && context === "profile") return PENDING_LABEL;
  return null;
}

export function getDealerVerificationTooltip(dealer) {
  const state = getDealerVerificationPublicState(dealer);
  if (state.state === "verified") return VERIFIED_TOOLTIP;
  if (state.state === "pending") return PENDING_TOOLTIP;
  return null;
}

export function isVerifiedDealer(listingOrDealer) {
  return shouldShowDealerVerificationBadge(listingOrDealer);
}

export function trackDealerVerificationEvent(eventType, metadata = {}) {
  if (typeof window !== "undefined" && window.__midpointTrack) {
    window.__midpointTrack(eventType, metadata);
  } else if (process.env.NODE_ENV !== "production") {
    console.debug("[dealer-verification-event]", eventType, metadata);
  }
}
